import {Directive, forwardRef} from '@angular/core';
import {NG_VALIDATORS} from '@angular/forms';
import {validateCardNumber} from '@atlas/businesstypes';

import {AbstractValidatorDirective} from '../base/validator';

/**
 * @ngModule BusinessTypesModule
 */
@Directive({
  selector: '[atlasCardNumber]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BaseCardNumberValidator),
      multi: true,
    },
  ],
})
export class BaseCardNumberValidator extends AbstractValidatorDirective {
  protected readonly validatorFn = validateCardNumber;
}
